<template>
  <v-col cols="12" class=" py-0">
    <v-dialog v-model="dialog" persistent max-width="800">
      <v-card :loading="loading" v-if="newArticle">
          <v-card-title :class="`${arabic?'arFont':'enFont'} font-weight-bold`" style="font-size:22px;">
            <div>{{ i18n.articles + ' | ' }} <span class="font-weight-light">{{ newArticle.id ? i18n.edit : i18n.add }}</span> </div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4" class="py-0">
                <v-text-field
                  :label="i18n.title"
                  :name="getNameID()"
                  :rules="[rules.required]"
                  :id="getNameID()"
                  :class="`${arabic ? 'arFont' : 'enFont'}`"
                  v-model="newArticle.title"
                  autocomplete="disabled"
                  dense
                  outlined
                />
              </v-col>
              <v-col cols="12" md="4" class="py-0">
                <Field
                  :field="imageField"
                  :item="newArticle"
                  @getUpload="getUpload"
                />
              </v-col>
              <v-col cols="12" md="4" class="py-0">
                <v-text-field
                  :label="i18n.order"
                  :rules="[rules.required]"
                  v-model="newArticle.order"
                  type="number"
                  outlined
                  dense
                  item-value="id"
                  item-text="label"
                />
              </v-col>
              <v-col cols="12" md="4" class="py-0">
                <v-autocomplete
                  :items="categories"
                  :class="`${arabic?'arFont':'enFont'}`"
                  :label="i18n.category"
                  :rules="[rules.required]"
                  v-model="newArticle.category_id"
                  outlined
                  dense
                  item-value="id"
                  item-text="label"
                />
              </v-col>
              <v-col cols="12" md="4" class="py-0">
                <v-autocomplete
                  :items="keywords"
                  :class="`${arabic?'arFont':'enFont'}`"
                  :label="i18n.keyword"
                  :rules="[rules.required]"
                  v-model="newArticle.keyword_ids"
                  multiple
                  outlined
                  dense
                  item-value="id"
                  item-text="label"
                />
              </v-col>
              <v-col cols="12" md="4" class="py-0">
                <v-autocomplete
                  :items="types"
                  :class="`${arabic?'arFont':'enFont'}`"
                  :label="i18n.type"
                  :rules="[rules.required]"
                  v-model="newArticle.type"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" md="4" class="py-0">
                <v-textarea
                  :label="i18n.body"
                  :rules="[rules.required]"
                  v-model="newArticle.body"
                  outlined
                  dense
                />
              </v-col>

              <template v-if="newArticle.type == 'video'">
                <v-col cols="12" md="4" class="py-0">
                  <v-text-field
                    :class="`${arabic?'arFont':'enFont'}`"
                    :label="i18n.video_url"
                    :rules="[rules.required]"
                    v-model="newArticle.url"
                    outlined
                    dense
                  />
                </v-col>
              </template>

            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error" 
              text 
              :class="`${arabic?'arFont':'enFont'}`"
              @click.native="closeDialog"
            >{{i18n.cancelBtn}}</v-btn>
            <v-btn
              :disabled="!validate()" 
              color="success" 
              v-if="!newArticle.id"
              text 
              :class="`${arabic?'arFont':'enFont'}`"
              @click.native="postResource(newArticle)"
            >
              {{i18n.submitBtn}}
            </v-btn>
            <v-btn
              :disabled="!validate()" 
              color="success" 
              v-if="newArticle.id"
              text 
              :class="`${arabic?'arFont':'enFont'}`"
              @click.native="updateResource(newArticle)"
            >
              {{i18n.updateBtn}}
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
  </v-col>
</template>
<script>
import { randomString } from '@/customFunction';
import typeMixins from '@/mixings/isType';
import Field from './Field.vue';

export default {
  components: {Field},
  props: ['article', 'categories', 'keywords', 'loading', 'dialog'],
  mixins: [typeMixins],
  data() {
    return {
      imageField: {
        name: "image",
        type: 'upload',
        label: 'image',
        info: { en: '', ar: '' }
      },
      newArticle: {
        type: null,
        image: null,
        url: null,
        title: null,
        body: null,
        category_id: null,
        keyword_ids: null,
        video_url: null,
        order: null
      },
      types: null,
      rules: null,
    }
  },
  created() {
    this.types = [
      {
        text: this.i18n["video"],
        value: 'video',
      },
      {
        text: this.i18n["article"],
        value: 'article',
      }
    ];

    this.rules = {
      required: value => !!value || this.i18n['required'],
      email: value =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
        this.i18n['valid_email']
    };
  },
  watch: {
    dialog: function (value) {
      if (value && this.article.id) {
        // console.log(this.article);
        this.newArticle = {...this.article}
        this.newArticle.keyword_ids = this.newArticle.keywords.map(function (keyword) {
          return keyword.id
        })
      }
    }
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    language(){
      return this.$store.state.language
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
  },
  methods: {
    getUpload({field, value})
    {
      // console.log(field, value);
      this.newArticle[field] = value 
    },
    validate() {
      return this.newArticle.title && this.newArticle.image && this.newArticle.category_id && 
        this.newArticle.keyword_ids && this.newArticle.type && this.newArticle.body && this.newArticle.order
    },
    async updateResource(data) {
      return new Promise(async (res, rej) => {
        this.$emit('updateLoadingState', true)

        await this.$store.dispatch('putResource', {
          resource: '/help/articles/' + this.article.id,
          value: data,
        });

        this.closeDialog()

        this.$emit('updateLoadingState', false)

        this.$emit('loadResource')
      });
    },
    async postResource(resource) {
      this.$emit('updateLoadingState', true)

      await this.$store.dispatch('postResource', {
        resource: '/help/articles',
        value: resource,
      });
      
      this.closeDialog()
      
      this.$emit('updateLoadingState', false)

      this.$emit('loadResource')
    },
    getNameID(){
      return randomString(24, '#Aa') + `${new Date().getTime()}`
    },
    saveResourceHandler() {
      this.$emit('on-save', this.article);
    },
    updateResourceHandler() {
      this.$emit('on-update', this.article);
    },
    filterObject(item, queryText, itemText) {
      const v = Object.values(item).filter((x) => typeof x === 'string');
      let a = false;
      v.forEach((x) => {
        if (x.toLowerCase().includes(queryText.toLowerCase())) a = true;
      });
      if (itemText && typeof itemText === 'string' && itemText.toLowerCase().includes(queryText
        .toLowerCase())) a = true;
      return a;
    },
    closeDialog() {
      this.newArticle = {
        type: null,
        image: null,
        url: null,
        title: null,
        body: null,
        category_id: null,
        keyword_ids: null,
        video_url: null,
        order: null
      }
      
      // console.log(this.newArticle);

      this.$emit('closeDialog');
    },
  },
};
</script>

<style></style>
